// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6294":"0f1b3dc6","7505":"0195bc56","8665":"5039d775"}[chunkId] + ".chunk.css";
};